import { API_CONFIG } from "config/api.config";
import { ProfileModel } from "model/profile/profile.schema";
import { AdminsModel } from "model/admins/admins.schema";
import PayloadModel from "model/_payload/payload.schema";
import { createBaseApi } from "../baseApi";

export const adminsApi = createBaseApi("admin", "/admins").injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    // Get Admins List
    getAdmins: builder.query({
      query: (value) => {
        const payload = PayloadModel.modelToJson(value);
        return {
          url: "",
          method: "GET",
          params: payload,
        };
      },
      providesTags: ["Admins"],
      transformResponse: (response) => {
        return AdminsModel.jsonToModel(response);
      },
    }),

    // Add Admin
    addAdmin: builder.mutation({
      query: (payload) => {
        return {
          url: "",
          method: "POST",
          body: payload,
        };
      },
      invalidatesTags: ["Admins"],
      transformResponse: (response) => {
        return response;
      },
    }),

    // Get Admin
    getAdmin: builder.query({
      query: (id) => {
        return {
          url: `/${id}`,
          method: "GET",
        };
      },
      providesTags: ["Admins"],
      transformResponse: (response) => ProfileModel.jsonToModel(response),
    }),

    // Update Profile
    updateAdmin: builder.mutation({
      query: (payload) => ({
        url: `/${payload.id}`,
        method: "PATCH",
        body: payload,
      }),
      invalidatesTags: ["Admins"],
      transformResponse: (response) => ProfileModel.jsonToModel(response),
    }),

    // Update Admin Password
    updateAdminPassword: builder.mutation({
      query: (value) => {
        const payload = PayloadModel.modelToJson(value);
        return {
          url: API_CONFIG.USE_MOCK ? "/admins/update-password.json" : `/admins/update-password/${value.adminId}`,
          method: "PUT",
          body: { password: payload.password },
        };
      },
      invalidatesTags: ["Admin"],
      transformResponse: (response) => {
        return response;
      },
    }),

    // Delete Admin
    deleteAdmin: builder.mutation({
      query: (value) => {
        const ids = Array.isArray(value) ? value : [value];
        const payload = {
          ids,
          is_active: false,
        };
        console.log(payload);
        return {
          url: "/delete",
          method: "PUT",
          body: payload,
        };
      },
      invalidatesTags: ["Admins"],
      transformResponse: (response) => {
        return response;
      },
    }),
  }),
});

export const { useGetAdminsQuery, useGetAdminQuery, useAddAdminMutation, useUpdateAdminMutation, useUpdateAdminPasswordMutation, useDeleteAdminMutation } = adminsApi;
